import React from "react";
import "./App.css";
import AppInitializer from "./AppInitializer";
import { ThemeProvider } from "@emotion/react";
import AppThemeConfig from "./Configurations/AppThemeConfig";
import { CssBaseline } from "@mui/material";
import { Toaster } from "react-hot-toast";

function App() {
  return (
    <ThemeProvider theme={AppThemeConfig}>
      <CssBaseline>
        <Toaster position="top-center" reverseOrder={false} />
        <AppInitializer />
      </CssBaseline>
    </ThemeProvider>
  );
}

export default App;
